import React, { Component } from 'react';
import Modal from 'react-modal';
import shoppingCart from '../asset/img/shoppingCart.png';
import ShoppingCart from './ShoppingCart.js'; //component that contains the shopping cart
import axios from 'axios';
import {path,mail,storeImagePath} from './routes.js';
import Gift from './Gift.js'; //component that contains each gift and its information
import SelectBox from '../component/Select.js';
import Validation from './Validation.js'; //used for validation
import loader from '../asset/img/loader.gif';
import PropTypes from 'prop-types';

export default class ASMGiftShop extends Component {
	constructor(props){
		super(props);
		this.state = {
						info: [],
						modalIsOpen: false,
						lowInventory: [],
						adminEmail: '',
						adminName: '',
						approval: '',
						notes: '',
						tier: 'All',
						tierInfo: [],
						tierOptions: [],
						success: false,
						validNotes: true,
						validShipping: true,
						loading: false,
						modalPrompt: '',
						asmList: [],
						chosenAsm: '',
						cartChangeGift: {
							prize: '',
							sizeIndex: 0,
							colorIndex: 0
						},
						didCartChange: false,
						chosenAsmIndex: -1,
						states: [],
						currentBudget: 0,
						shippingInfo: {
							street_address:'',
							city:'',
							state:'',
							zipcode:'',
							shipping_instructions:''
						}
					 };
		this.addToCart = this.addToCart.bind(this);
		// this.cartTotal = this.cartTotal.bind(this);
		this.getGifts = this.getGifts.bind(this);
		this.removeItem = this.removeItem.bind(this);
		this.openModal = this.openModal.bind(this);
	    this.closeModal = this.closeModal.bind(this);
	    this.handleSelection = this.handleSelection.bind(this);
	    this.quantityChange = this.quantityChange.bind(this);
	    this.submitOrder = this.submitOrder.bind(this);
	    this.handleInput = this.handleInput.bind(this);
	    this.updateInfo = this.updateInfo.bind(this);
	    this.selectAsm = this.selectAsm.bind(this);
	    this.leaveShop = this.leaveShop.bind(this);
	    this.getASMinfo = this.getASMinfo.bind(this);
	}

	selectAsm(){
		const {chosenAsm,asmList} = this.state;
		for(let i=0;i<asmList.length;i++){
			if(asmList[i].name === chosenAsm){
				this.setState({chosenAsmIndex:i,modalIsOpen:false,currentBudget:asmList[i].budget});
				break;
			}
		}
	}

	handleSelection(identity,value){ //standard method for updating the state based on user input from select fields
		const theState = this.state;
		if(value !== "All" && value !== "New" && value !== "Discontinued"){
			value = value.replace(/\$/g,'');
			value = value.replace(/\s/g,'');
			let range = value.split("-");
			for(let i=0;i<this.state.tierInfo.length;i++){
				if(Number(range[1])===Number(this.state.tierInfo[i].points)){
					theState[identity] = this.state.tierInfo[i].tier;
					break;
				}
			}
		}else{
			theState[identity] = value;
		}
		this.setState(theState);
	}

	addToCart(item){ //method for handling an item being added to the shopping cart
		let theCart = [];
		let exists = false;
		for(let i=0;i<this.props.cart.length;i++){ //check to see if the shopping cart already contains an item
			theCart[i] = this.props.cart[i];
			if(item.prize === theCart[i].prize && item.size === theCart[i].size && item.color === theCart[i].color){
				exists = true;
				theCart[i].quantity = Number(item.quantity) + Number(this.props.cart[i].quantity);
				theCart[i].total = (Number(item.total) + Number(this.props.cart[i].total)).toFixed(2);
			}
		}
		if(!exists){
			theCart.push(item);
		}

		this.updateInfo(item,'add');
		this.props.updateCart(theCart,this.props.updateCartTotal(item,'add'));
		let currentBudget = Number(this.state.currentBudget) - Number(item.total);
		this.setState({currentBudget:currentBudget.toFixed(2)});

	}

	handleInput(identity,value){ //standard method for updating the state based on user input from input fields
		let theState;
		if(identity === "chosenAsm" || identity === "notes"){
			theState = {};
		}else{
			theState = this.state.shippingInfo;
		}
		theState[identity] = value;
		this.setState(theState);
	}

	updateInfo(item,action){ //method that updates the state to reflect current quantity available of an item based on the user adding to or removing from shopping cart
		let cartChangeGift = {...this.state.cartChangeGift};
		let didCartChange = this.state.didCartChange;
		let newInfo = [];
		let item_size, item_color;
		for( let j = 0; j < this.state.info.length; j++ ){
			newInfo.push(this.state.info[j]);

			if( item.prize === newInfo[j].prize ){

				for( let i = 0; i < newInfo[j].variants.length; i++ ){

					item_size = item.size === 'N/A' ? null : item.size;
					item_color = item.color === 'N/A' ? null : item.color.replace(' ','_');

					if( item_size === newInfo[j].variants[i].size && item_color === newInfo[j].variants[i].color ){
						//if( item.size === newInfo[j].variants[i].size && item.color === newInfo[j].variants[i].color ){
						cartChangeGift.prize = item.prize;
						cartChangeGift.sizeIndex = item.variationsIndex.sizeIndex;
						cartChangeGift.colorIndex = item.variationsIndex.colorIndex;
						didCartChange = !this.state.didCartChange;
						if( action==='add' ){
							newInfo[j].variants[i].currentQuantity = Number(newInfo[j].variants[i].currentQuantity) - Number(item.quantity);
						}else if( action==='remove' ){
							newInfo[j].variants[i].currentQuantity = Number(newInfo[j].variants[i].quantity);
						}
					}
				}
			}
		}
		this.setState({
			info: newInfo,
			cartChangeGift: cartChangeGift,
			didCartChange: didCartChange
		});
	}

	removeItem(index){ //method for handling the removal of a line item from the shopping cart
		let items = this.props.cart;
		let newTotal = Number(this.state.currentBudget) + Number(items[index].total);
		this.updateInfo(this.props.cart[index],'remove');
		this.props.updateCart(items,this.props.updateCartTotal(items[index],'remove'));
		this.setState({currentBudget:newTotal.toFixed(2)});
	}

	quantityChange(id,newQuant){ //method for handling the quantity of a line item from the shopping cart
		let info = this.state.info;
		let items = this.props.cart;
		let GiftIndex = -1, variantIndex = -1;
		let item_size, item_color;
		const budget = (this.props.userInfo.userType === "asm_admin" || this.props.userInfo.userType === "sys_admin")?this.state.asmList[this.state.chosenAsmIndex].budget:this.props.userInfo.budget;
		if( Number(newQuant) > 0 ){ //if the quantity is not 0, perform operations for changing line item quantity 
			for( let i = 0; i < info.length; i++ ){
				
				if( info[i].prize === items[id].prize ){
					GiftIndex = i;
					for( let j = 0; j < info[i].variants.length; j++ ){

						item_size = items[id].size === 'N/A' ? null : items[id].size;
						item_color = items[id].color === 'N/A' ? null : items[id].color.replace(' ','_');

						if( info[i].variants[j].size == item_size && info[i].variants[j].color == item_color ){
							variantIndex = j;
							if( Number(info[i].variants[j].quantity) - Number(newQuant) < 0 ){//change made here
								newQuant = Number(info[i].variants[j].quantity);
							}else if( info[i].variants[j].limit && Number.isFinite(info[i].variants[j].limit) && Number(info[i].variants[j].limit) - Number(newQuant) < 0 ){
								newQuant = Number(info[i].variants[j].limit);
							}else{
								newQuant = Number(newQuant);
							}

						}

					}
				}
			}
			let unitPrice = Number((items[id].total)/(items[id].quantity));
			unitPrice = unitPrice.toFixed(2);
			let notaffordable = true;
			let newTotal;
			while(notaffordable){
				let newItemTotal = Number(newQuant*unitPrice).toFixed(2);
				items[id].quantity = Number(newQuant);
				items[id].total = Number(newItemTotal);
				newTotal = 0;
				items.forEach((item)=>{
					newTotal = (Number(item.total) + Number(newTotal));
				});
				if(newTotal <= budget){
					notaffordable = false;
				}else{
					newQuant--;
				}
			}

			info[GiftIndex].variants[variantIndex].currentQuantity = Number(info[GiftIndex].variants[variantIndex].quantity) - (newQuant);
			let currentBudget = budget - newTotal;
			this.setState({
				info:info,
				currentBudget:Number(currentBudget).toFixed(2),
				cartChangeGift: {
					prize: items[id].prize,
					sizeIndex: items[id].variationsIndex.sizeIndex,
					colorIndex: items[id].variationsIndex.colorIndex
				},
				didCartChange: !this.state.didCartChange
			});
			this.props.handleInput('cartTotal',newTotal);
		}else{ //if quantity is 0, remove item from shopping cart
			this.removeItem(id);
		}
	}

	getGifts(){ //method to retrieve all gift information for current year from database
		let gifts = [];
		axios({
			method: 'post',
			url: path,
			headers: { 'Content-Type': 'application/json' },
			data: {
				endpoint: 'info',
				table: 'prizes',
				kind: 'test',
				action: '_asm_shop'
			}
		}).then((response)=>{
			let giftInfo = response.data.data;
			let j = 0;
			if ( giftInfo.length > 0 ){
				gifts.push({
					prizeID: giftInfo[0].prizeID,
					prize: giftInfo[0].prize,
					tier: giftInfo[0].tier,
					picture: storeImagePath+giftInfo[0].picture,
					description: giftInfo[0].description,
					status: giftInfo[0].status,
					variants:[
						{
							variantID:giftInfo[0].variantID,
							size:giftInfo[0].size,
							color:giftInfo[0].color,
							photo:giftInfo[0].photo,
							threshold: giftInfo[0].threshold,
							currentQuantity: giftInfo[0].quantity,
							quantity: giftInfo[0].quantity,
							price: giftInfo[0].price,
							limit: giftInfo[0].orderLimit
						}
					]
				});
				for ( let i = 1; i < giftInfo.length; i++ ){
					if( giftInfo[i].prizeID === gifts[j].prizeID ){
						gifts[j].variants.push({
							variantID:giftInfo[i].variantID,
							size:giftInfo[i].size,
							color:giftInfo[i].color,
							photo:giftInfo[i].photo,
							threshold: giftInfo[i].threshold,
							currentQuantity: giftInfo[i].quantity,
							quantity: giftInfo[i].quantity,
							price: giftInfo[i].price,
							limit: giftInfo[i].orderLimit
						});
					} else {
						gifts.push({
							prizeID: giftInfo[i].prizeID,
							prize: giftInfo[i].prize,
							tier: giftInfo[i].tier,
							picture: storeImagePath+giftInfo[i].picture,
							description: giftInfo[i].description,
							status: giftInfo[0].status,
							variants:[
								{
									variantID:giftInfo[i].variantID,
									size:giftInfo[i].size,
									color:giftInfo[i].color,
									photo:giftInfo[i].photo,
									threshold: giftInfo[i].threshold,
									currentQuantity: giftInfo[i].quantity,
									quantity: giftInfo[i].quantity,
									price: giftInfo[i].price,
									limit: giftInfo[i].orderLimit
								}
							]
						});
						j++;
					}
				}
			}
			this.setState({info:gifts});
		});
	}

	componentDidUpdate(prevProps){ //method that retrieves updated gift information from database once an order has been submitted
		if(prevProps.submitted !== this.props.submitted){
			this.getGifts();
			if(this.props.userInfo.userType === 'asm_admin'|| this.props.userInfo.userType === "sys_admin"){
				this.getASMinfo(false);
			}
		}
		if(prevProps.active !== this.props.active && (this.props.userInfo.userType === 'asm_admin'|| this.props.userInfo.userType === "sys_admin") && this.props.active){
			this.setState({modalIsOpen:true,chosenAsm:this.state.asmList[0].name,chosenAsmIndex:-1});
		}
	}

	componentDidMount(){ //when component mounts, retrieve gift information,regional threshold information,admin email, and tiers for current year
		this.getGifts();
		let year = (new Date()).getFullYear();
		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'tiers',kind:this.props.app,year:year,action:'shop'}
		}).then((response)=>{
			let data = response.data.data;
			let tierOptions = [];
			tierOptions.push("$00.01 - $"+data[0].points.toFixed(2));
			for(let i=1;i<data.length;i++){
				let min = Number(data[i-1].points) + 0.01; 
				tierOptions.push("$"+min+" - $"+data[i].points.toFixed(2));
			}
			this.setState({tierInfo:data,tierOptions:tierOptions});
		});

		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'state'}
		}).then((response)=>{
			let states = [];
			let data = response.data.data;
			let shipping = this.state.shippingInfo;
			if(data){
				for(let j = 0; j < data.length; j++ ){
					states.push(data[j].Abbrev);
				}
				shipping['state'] = data[0].Abbrev;
			}
			this.setState({states:states,shippingInfo:shipping});
		});

		if(this.props.userInfo.userType === 'asm_admin'|| this.props.userInfo.userType === "sys_admin"){
			this.getASMinfo();
		}else{
			this.setState({currentBudget:this.props.userInfo.budget});
		}
		// axios({
		// 	method:'post',
		// 	url:path,headers:{'Content-Type':'application/json'},
		// 	data:{endpoint:'info',table:'department',action:'threshold',userID:this.props.userInfo.userID,name:this.props.userInfo.department}
		// }).then((response)=>{
		// 	let data = response.data.data;
		// 	if(data !== undefined && data[0] !== undefined){
		// 		this.setState({regionalThreshold:data[0].threshold,approval:data[0].approval,adminEmail:data[0].email,adminName:data[0].name});
		// 	}
		// });

		let sessiontotal = 0;
		this.props.cart.forEach((item)=>{
			sessiontotal = Number(item.total) + Number(sessiontotal);
		});
		this.setState({cart:this.props.cart,total:sessiontotal});
	}

	openModal() { //method for opening the modal
    	this.setState({modalIsOpen: true});
	}

	closeModal() { //method for closing the modal
	    this.setState({modalIsOpen: false,success:false});
	}

	leaveShop(){
		this.setState({chosenAsm:this.state.asmList[0].name,chosenAsmIndex:-1,modalIsOpen:false,success:false},function(){
			this.props.leaveShop();
		});
	}

	getASMinfo(firstMount){
		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'users',action:'asm_shop'}
		}).then((response)=>{
			let data = response.data.data;
			if(firstMount){
				this.setState({asmList:data,chosenAsm:data[0].name});
			}else{
				this.setState({asmList:data});
			}
		});
	}

	submitOrder(){ //method that handles all operations required for submitting an order
		let userType = this.props.userInfo.userType;
		const total = this.props.cartTotal;
		const budget = (userType === "asm_admin" || this.props.userInfo.userType === "sys_admin")?this.state.asmList[this.state.chosenAsmIndex].budget:this.props.userInfo.budget;
		if(total <= budget){
			const cart = this.props.cart;
			const {info,notes,approval,shippingInfo} = this.state;
			let validshipping = true;
			let validnotes = true;
			//validate additional notes field
			if(!Validation("reason",notes) || notes.trim() === ''){
				validnotes = false;
				document.getElementById("notes").style.borderColor = "red";
				if(notes.trim() === ''){
					document.getElementById("notes_span").textContent = "Required";
				}else{
					document.getElementById("notes_span").textContent = "Invalid characters";
				}
			}else{
				document.getElementById("notes").style.borderColor = "inherit";
				document.getElementById("notes_span").textContent = "";
			}
			let notValidFields = [];
			for(let thekey in this.state.shippingInfo){
				if((thekey !== "shipping_instructions")&&(thekey !== "state")){
					if(document.getElementById("city").value.trim() === ''){
						document.getElementById("city").style.borderColor = "red";
						document.getElementById("city_span").textContent = "Required";
					}else{
						document.getElementById("city").style.borderColor = "inherit";
						document.getElementById("city_span").textContent = "";
					}
					if(!Validation(thekey,this.state.shippingInfo[thekey] || this.state.shippingInfo[thekey].trim() === '')){
						validshipping = false;
						document.getElementById(thekey).style.borderColor = "red";
						let text;
						if(this.state.shippingInfo[thekey].trim() ===''){
							text = "Required";
						}else{
							text = "Invalid characters";
						}
						document.getElementById(thekey+"_span").textContent = text;
						//notValidFields.push(thekey);
					}else{
						document.getElementById(thekey).style.borderColor = "inherit";
						document.getElementById(thekey+"_span").textContent = "";
					}
				}else if(thekey === "shipping_instructions" && this.state.shippingInfo.shipping_instructions.trim() !== ''){
					if(!Validation("reason",this.state.shippingInfo[thekey])){
						validshipping = false;
						document.getElementById(thekey).style.borderColor = "red";
						document.getElementById(thekey+"_span").textContent = "*Invalid characters";
						//notValidFields.push(thekey);
					}else{
						document.getElementById(thekey).style.borderColor = "inherit";
						document.getElementById(thekey+"_span").textContent = "";
					}
				}
			}
			if(validnotes && validshipping){ //if additional notes and order instructions contain valid input, begin submitting order
				let userID = (userType === "asm_admin" || userType === "sys_admin")?this.state.asmList[this.state.chosenAsmIndex].userID:this.props.userInfo.userID;
				//const status = this.props.userInfo.userType === 'asm_admin'?"admin_order":"pending"; //determine if order goes straight to admin approval or not
				const misc = (this.props.userInfo.userType === "asm_admin" || this.props.userInfo.userType === "sys_admin")?'admin_create':'create';
				const orderNotes = notes.trim() === ''?null:notes;
				const instructions = shippingInfo.shipping_instructions.trim() === ''?null:shippingInfo.shipping_instructions;
				let orderData = { //all order data 
					endpoint:'create',
					table:'asm_order',
					misc:misc,
					firstID:userID,
					cost:total,
					date:'required',
					name:shippingInfo.street_address,
					email:shippingInfo.city,
					answer:shippingInfo.state,
					picture:shippingInfo.zipcode,
					status:instructions,
					desc:orderNotes
				};
				this.setState({loading:true});
					axios({ //create order in orders table
						method:'post',
						url:path,
						headers:{'Content-Type':'application/json'},
						data:orderData
					}).then((response)=>{ //create line items for order in line items table
							let res = response.data.data;
							if(res.ID !== 0){
								let thresholdReached;
								let overThreshold = [];
								let orderItemsForEmail = [];
								let lineitems = [];
								cart.forEach((orderItem)=>{
									let prizeID, variantID;
									if( orderItem.size === "" || orderItem.size === "N/A" ){ //prepare data 
										orderItem.size = null;
									}
									if( orderItem.color === "N/A" ){
										orderItem.color = null;
									}
									for( let i = 0; i < info.length; i++ ){
										if( orderItem.prize === info[i].prize ){
											prizeID = info[i].prizeID;
											info[i].variants.forEach((vari)=>{ //get the right variantID for each prize variant that is being ordered
												if( (orderItem.size === vari.size) ){ //begin
													if( orderItem.color !== null ){
														if( orderItem.color === vari.color || orderItem.color.replace(" ","_") === vari.color || orderItem.color.replace("_"," ") === vari.color ){
															variantID = vari.variantID;
															thresholdReached = (vari.quantity - orderItem.quantity <= vari.threshold) ? true : false;
														}
													}else{
														if( orderItem.color === vari.color ){
															variantID = vari.variantID;
															thresholdReached = (vari.quantity - orderItem.quantity <= vari.threshold) ? true : false;
														}
													}
												}
											});
											
										}
									}
									if(thresholdReached){
										overThreshold.push(orderItem.prize);
									}
									lineitems.push(
										axios({
											method:'post',
											url:path,
											headers:{'Content-Type':'application/json'},
											data:{
												endpoint:'create',
												table:'asm_item',
												misc:'create_order_item',
												firstID:res.ID,
												secondID:prizeID,
												thirdID:variantID,
												quantity:orderItem.quantity
											}
										})
									);
									orderItemsForEmail.push({
										item: orderItem.prize,
										quantity: orderItem.quantity,
										ID: prizeID,
										variantID: variantID,
										size: (orderItem.size === null ? 'N/A' : orderItem.size),
										color: (orderItem.color === null ? 'N/A' : orderItem.color)
									});
								});
								axios.all(lineitems).then((resp)=>{
									let admin_email = resp[0].data.data.email;
									let admin_name = resp[0].data.data.name;
									if(overThreshold.length > 0){
										overThreshold.forEach((over)=>{//if threshold was reached, email the asm admin --this.state.adminEmail--'name':this.state.adminName
											axios({
												method:'post',
												url:mail,
												headers:{'Content-Type':'application/json'},
												data:{'action':'item_threshold','type':'asm','email':admin_email,'prize':over,'name':admin_name}
											});
										});
									}
									let orderName = (this.props.userInfo.userType === 'asm_admin' || this.props.userInfo.userType === 'sys_admin')?this.state.chosenAsm:this.props.userInfo.name;
									axios({ //email letting the asm admin know that an order has been placed
										method:'post',
										url:mail,
										headers:{'Content-Type':'application/json'},
										data:{
											'action':'newOrder',
											'type':'asm',
											'email':admin_email,
											'name':admin_name,
											'orderName':orderName,
											'orderItems':orderItemsForEmail,
											'shippingInfo':this.state.shippingInfo,
											'notes':orderNotes,
											'orderID':res.ID
										}
									});
									if(this.props.userInfo.userType !== 'asm_admin' && this.props.userInfo.userType !== 'user' && this.props.userInfo.userType !== 'sys_admin'){
										this.props.budgetUpdate("subtract",total,false); //update budget, lov=false
									}
									this.props.updateCart([],this.props.updateCartTotal());
									this.setState({success:true, notes:'', loading:false,shippingInfo:{street_address:'',city:'',state:'',zipcode:'',shipping_instructions:''}},()=>{
										this.getGifts();
										this.props.logChange();
									});

								 });
							}
					});
			}else{ //let user know that their input is invalid
				// let modalPrompt = '';
				// let shippingState = this.state.shippingInfo;
				// 	if(!validnotes){
				// 		modalPrompt += 'Additional notes contains invalid input. ';
				// 	}
				// 	for(let v=0;v<notValidFields.length;v++){
				// 		if(shippingState[notValidFields[v]].trim() === ''){
				// 			modalPrompt += notValidFields[v]+' must be filled out. ';
				// 		}else{
				// 			modalPrompt += notValidFields[v]+' contains invalid characters. ';
				// 		}
				// 	}
				// 	// if(!validcenter){
				// 	// 	if(callcenter.trim() === ''){
				// 	// 		modalPrompt += 'Call center must be filled out. ';
				// 	// 	}else if(!Validation("callcenter",callcenter)){
				// 	// 		modalPrompt += 'Call center contains invalid characters. ';
				// 	// 	}
				// 	// }
				// this.setState({validNotes:false,notes:'',modalPrompt:modalPrompt},function(){
				// 	setTimeout(()=>{
				// 		this.setState({validNotes:true,modalPrompt:''});
				// 	},2000);
				// });
			}
		}
	}

	render(){
		let tierOptions = ["All","New","Discontinued",...this.state.tierOptions];
		const selectStyle = "w-80-ns w-100 ml2 h2 shadow-3 pa1 br2 b--gray bw1";
		const asmSelectStyle = "w-100 h2 shadow-3 pa1 br2 b--gray bw1";
		const selectButtonStyle = "bg-dark-blue white grow b br3 bn shadow-3 h2 w-100 mt2";
		let content;
		let customStyles = {
		  	content : {
			    top: '50%',
			    left: '50%',
			    right: 'auto',
			    bottom: 'auto',
			    width:'100%',
			    maxWidth:'1080px',
			    transform: 'translate(-50%, -50%)',
			    boxShadow:'0.5px 0.5px 1px 0.5px',
			    paddingTop:'10px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		let itemTotal = this.props.cart.length;
		const cartButton = {
			backgroundImage: 'url(' + shoppingCart + ')',
			backgroundSize: '60px 40px',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			minWidth:'65px', minHeight:'45px',
		};
		let asmNames = [];
		for(let i=0;i<this.state.asmList.length;i++){
			asmNames.push(this.state.asmList[i].name);
		}
		let information = this.state.info;
		const limitBudget = ((this.props.userInfo.userType === "asm_admin" || this.props.userInfo.userType === 'sys_admin') && this.state.chosenAsmIndex !== -1)?this.state.asmList[this.state.chosenAsmIndex].budget:this.props.userInfo.budget;
		const currentBudget = (limitBudget - this.props.cartTotal).toFixed(2);
		let gifts = information.map((information,i) => {
			let item_name = information.status === 'active'?information.prize:information.prize+" ("+information.status+")";
			if(information.tier == this.state.tier || this.state.tier === "All"){ //return all gifts to display based on the tier chosen
				return(
					<div className="fl w-33-ns w-50-m w-100 pa1 prizeDiv" key={i}>
						<Gift
							prize={item_name}
							path={information.picture}
							variants={information.variants}
							onChoice={this.addToCart}
							description={information.description}
							child={i}
							currentBudget={currentBudget}
							cartChangeGift={this.state.cartChangeGift}
							didCartChange={this.state.didCartChange}
							cart={this.props.cart}
						/>
					</div>
				)
			}else if(information.status === this.state.tier){
				return(
					<div className="fl w-33-ns w-50-m w-100 pa1 prizeDiv" key={i}>
						<Gift
							prize={item_name}
							path={information.picture}
							variants={information.variants}
							onChoice={this.addToCart}
							description={information.description}
							child={i}
							currentBudget={currentBudget}
						/>
					</div>
				)
			}
		});
		if(this.props.active){
			let modalContent;
			if(this.state.loading){ //display loader 
				modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
			}else if(this.state.success){ //display success message if order placed successfully
				if(this.props.userInfo.userType !== 'asm_admin' || this.props.userInfo.userType !== 'sys_admin'){
					modalContent = <div>
										<div className="fl w-100 tr">
								        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
								        </div>
										<p className="f3 navy tc">Your order has been placed! You will receive an email once it has been shipped.</p>
									</div>;
				}else{
					modalContent  = <div>
										<p className="f3 navy tc fl w-100">Your order for {this.state.chosenAsm} has been placed! Would you like to place another order?</p>
										<div className = "fl w-100 tc">
											<div className="fl w-50 tr pa2">
												<button className="w-50 bg-dark-blue white br3 pa2" style={{maxWidth:'100px'}} onClick={()=>{this.setState({chosenAsm:this.state.asmList[0].name,chosenAsmIndex:-1,success:false})}}>Yes</button>
											</div>
											<div className="fl w-50 tl pa2">
												<button className="w-50 bg-dark-blue white br3 pa2" style={{maxWidth:'100px'}} onClick={this.leaveShop}>No</button>
											</div>
										</div>
									</div>;
				}
			}else if(!this.state.validNotes || !this.state.validShipping){ //display message that user input was invalid
				modalContent = <div>
									<div className="fl w-100 tr">
							        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
							        </div>
									<p className="f3 navy tc">{this.state.modalPrompt}</p>
								</div>;
			}else if((this.props.userInfo.userType === 'asm_admin' || this.props.userInfo.userType === 'sys_admin') && this.state.chosenAsmIndex === -1){
				customStyles.content.maxWidth = "500px";
				modalContent = <div className="pa0 mb2">
									<div className="fl w-100 tr pa0">
								    <button className="bg-white gray b br3" onClick={this.leaveShop}>X</button>
								  </div>
								  <div className="fl w-100">
								  	<div className="fl w-100 pb2">
								  		<label className="navy b">Select an ASM: </label>
								  	</div>
								  	<div className="fl w-100">
								  		<SelectBox name="chosenAsm" identity="chosenAsm" onSelect={this.handleInput} options={asmNames} styles={asmSelectStyle} val={this.state.chosenAsm}/>
								  	</div>
								  	<div className="fl w-100"  style={{width:'100px',maxWidth:'100px',margin:'auto'}}>
								  		<button className={selectButtonStyle} onClick={this.selectAsm}>Select</button>
								  	</div>
								  </div>
								</div>;
			}else{ //display shopping cart
				modalContent = <div className="pa0">
								<div className="fl w-100 tr pa0">
							        <button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
							    </div>
								<ShoppingCart
									items={this.props.cart}
									total={this.props.cartTotal}
									remove={this.removeItem}
									quantChange={this.quantityChange}
									order={this.submitOrder}
									limit={limitBudget}
									app="asm"
									notes={this.handleInput}
									states={this.state.states}
								/>
								</div>;
			}
			let asmName;
			if((this.props.userInfo.userType === 'asm_admin' || this.props.userInfo.userType === 'sys_admin') && this.state.chosenAsm !== ''){
				asmName = this.state.chosenAsm+"'s";
			}
			content = <div>
						<div className="fl w-100 b--light-silver bb" style={{maxWidth:'100%'}}>
						<div className="fl w-30 tl mt2">
							<div className="mt2">
								<label className="b gray">{asmName} Budget: ${currentBudget}</label>
							</div>
						</div>
						<div className="fl w-40 tc mt2">
							<div className="fl w-50 tr mt2">
								<label className="b gray">Price Range: </label>
							</div>
							<div className="fl w-50 tl">
								<SelectBox name="tier" identity="tier" onSelect={this.handleSelection} options={tierOptions} styles={selectStyle}/>
							</div>
						</div>
						<div className="fl w-30 tr mb1">
							<button className="br3 bw1 b red bg-white bn shadow-1" onClick={this.openModal} style={cartButton}><span style={{display:'inline-block',marginRight:'11px', marginBottom:'11px'}}>{itemTotal}</span></button>
						</div>
						</div>
						<div className="fl w-100 overflow-y-auto pt2" style={{maxHeight:'500px'}}>
							{gifts}
						</div>
						<div>
							<Modal
					          isOpen={this.state.modalIsOpen}
					          style={customStyles}
					          contentLabel="shopping cart Modal"
					          shouldCloseOnOverlayClick={false}
					          shouldCloseOnEsc={false}
					        >
					        {modalContent}
					    </Modal>
						</div>
					</div>;
		}
		return(
			<div>
			{content}
			</div>
		);
	}
}


ASMGiftShop.propTypes = {
	userInfo: PropTypes.object.isRequired,
	app: PropTypes.string.isRequired,
	submitted: PropTypes.bool.isRequired,
	updateCart: PropTypes.func.isRequired,
	logChange: PropTypes.func.isRequired,
	cart: PropTypes.array.isRequired,
	active: PropTypes.bool.isRequired,
	cartTotal: PropTypes.number.isRequired,
	updateCartTotal: PropTypes.func.isRequired,
	handleInput: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/container/ASMGiftShop.js